export function mqttTopicReplace(topic: string, args: (string | null | undefined)[]): string {
    let argIndex = 0;
    return topic.split('+').map((part, index, arr) => {
        if (index < arr.length - 1) {
            return part + (args[argIndex++] || '+');
        }
        return part;
    }).join('');
}
